"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionLockRpcRemote = void 0;
const utils_1 = require("@streamr/utils");
const RpcRemote_1 = require("../dht/contact/RpcRemote");
const identifiers_1 = require("../identifiers");
const logger = new utils_1.Logger(module);
class ConnectionLockRpcRemote extends RpcRemote_1.RpcRemote {
    async lockRequest(lockId) {
        logger.trace(`Requesting locked connection to ${(0, identifiers_1.toNodeId)(this.getPeerDescriptor())}`);
        const request = {
            lockId
        };
        const options = this.formDhtRpcOptions();
        try {
            const res = await this.getClient().lockRequest(request, options);
            return res.accepted;
        }
        catch (err) {
            logger.debug('Connection lock rejected', { err });
            return false;
        }
    }
    unlockRequest(lockId) {
        logger.trace(`Requesting connection to be unlocked from ${(0, identifiers_1.toNodeId)(this.getPeerDescriptor())}`);
        const request = {
            lockId
        };
        const options = this.formDhtRpcOptions({
            notification: true
        });
        this.getClient().unlockRequest(request, options).catch((_e) => {
            logger.trace('failed to send unlockRequest');
        });
    }
    async gracefulDisconnect(disconnectMode) {
        logger.trace(`Notifying a graceful disconnect to ${(0, identifiers_1.toNodeId)(this.getPeerDescriptor())}`);
        const request = {
            disconnectMode
        };
        const options = this.formDhtRpcOptions({
            connect: false,
            sendIfStopped: true,
            timeout: 2000 // TODO use options option or named constant?
        });
        await this.getClient().gracefulDisconnect(request, options);
    }
    async setPrivate(isPrivate) {
        logger.trace(`Setting isPrivate: ${isPrivate} for ${(0, identifiers_1.toNodeId)(this.getPeerDescriptor())}`);
        const request = {
            isPrivate
        };
        const options = this.formDhtRpcOptions({
            connect: false,
            notification: true
        });
        await this.getClient().setPrivate(request, options);
    }
}
exports.ConnectionLockRpcRemote = ConnectionLockRpcRemote;
//# sourceMappingURL=ConnectionLockRpcRemote.js.map